{
    "sectionId": "config_data",
    "header": "Config",
    "available_actions": null,
    "attributes": [
      {
        "attribute_ID": "lkpDomainName",
        "fieldName": "lkpDomainName",
        "label": "Domain Name",
        "type": "input",
        "mandatory": "Y",
        "validator": null,
        "tooltip": "Please enter a Domain Name",
        "isAvailable": "Y",
        "placeholder": "Domain Name"
      },

      {
        "attribute_ID": "lkpDomainDesc",
        "fieldName": "lkpDomainDesc",
        "label": "Domain Description",
        "type": "text",
        "mandatory": "Y",
        "validator": null,
        "tooltip": "Please enter a Domain Description",
        "isAvailable": "Y",
        "placeholder": "Domain Description"
      }
    ],
    "validations": [
      {
        "whatToCheck": "atLeastXEntered",
        "clientOrServer": "C",
        "attributes": [
          {
            "validatorid": 1,
            "attribute_ID": ["lkpDomainName"],
            "functionParams": {
              "ErrMsg": "Please enter a domain name"
            }
          },
          {
            "validatorid": 2,
            "attribute_ID": ["lkpDomainDesc"],
            "functionParams": {
              "ErrMsg": "Please enter a domain description"
            }
          }
        ]
      }
    ],
    "actions": [
      {
        "Name": "Previous",
        "Validate": null
      },
      {
        "Name": "Next",
        "Validate": [
          {
            "checkType": "atLeastXEntered",
            "validatorid": [1, 2]
          }
        ]
      }
    ]
  }
  